import { AxiosRequestConfig } from "axios";
import _ from "lodash";

import { TXRequestConfig } from "@server/interfaces/frontend-api";

export const jsonCircularSafeStringify = (
	data: any,
	space?: string | number | undefined
) => {
	try {
		return JSON.stringify(data);
	} catch (err) {
		const cache: never[] = [];
		const circularRemovedDataString = JSON.stringify(
			data,
			(key, value) => {
				if (typeof value === "object" && value !== null) {
					if (cache.indexOf(value as never) !== -1) {
						return "[Circular]";
					}
					cache.push(value as never);
				}

				return value;
			},
			space
		);

		return circularRemovedDataString;
	}
};

export function extractLogDetails(requestConfig: AxiosRequestConfig) {
	const headers: TXRequestConfig["headers"] =
		requestConfig.headers as TXRequestConfig["headers"];

	const token = headers?.Authorization || "";
	const vendorID = headers?.vendor_id;
	const companyID = headers?.company_id;

	return `:: token: ${
		!token ? `-${token}-` : `${token.substring(token.length - 5)}`
	}, url: ${requestConfig.url}${!vendorID ? "" : `, vendorId: ${vendorID}`}${
		!companyID ? "" : `, companyID: ${companyID}`
	}`;
}

export function obfuscateCredentials<T>(config: T) {
	if (typeof config == "string") {
		const matches = config.matchAll(/Bearer[^\\]*/g);

		for (const match of matches) {
			const matchedString = match[0];
			config.replace(
				matchedString,
				`Bearer ***${matchedString.substring(matchedString.length - 10)}`
			);
		}

		return config;
	}

	const requestConfig = _.cloneDeepWith(config, (value, key) => {
		const substringLength = value?.length > 10 ? 10 : 1;

		if (key == "password") {
			return `*${value?.substring(value.length - substringLength)}`;
		}
		if (key == "token") {
			return `*${value?.substring(value.length - substringLength)}`;
		}
		if (key == "Authorization") {
			return `*${value?.substring(value.length - substringLength)}`;
		}
		if (key == "paramsSerializer") {
			return null;
		}
	}) as T;

	return requestConfig;
}
